import { createContext } from 'react';

const questionStepContext = createContext({
  currentStep: '',
});

export default questionStepContext;
